import {Inject, Injectable} from '@angular/core';
import {HelpdeskUrlConstants} from '@shared/constants/helpdesk-urls';
import {DialogBuilderFactoryService, DialogType, TranslateService, WINDOW} from '@vdw/angular-component-library';
import {Observable, Subject, takeUntil} from 'rxjs';

@Injectable()
export class CadCamService {
  public constructor(
    @Inject(WINDOW) private readonly window: Window,
    private readonly dialogBuilderFactoryService: DialogBuilderFactoryService,
    private readonly translate: TranslateService
  ) {}

  public openCadCam(target: HTMLElement, externalApplicationLinkObservable: Observable<string>, unSubscribeOnViewDestroy: Subject<boolean>): void {
    const dialogBuilder = this.dialogBuilderFactoryService.getBuilder();

    dialogBuilder
      .openAlertDialog({
        titleText: 'DESIGN_LIBRARY.CADCAM.DESCRIPTION',
        messageText: 'DESIGN_LIBRARY.CADCAM.EXTRA_INFORMATION',
        confirmButtonText: 'DESIGN_LIBRARY.CADCAM.ABOUT',
        informationUrl: HelpdeskUrlConstants.CADCAM,
        type: DialogType.REPORT
      })
      .subscribe(() => {
        target.onblur = null;
      });

    externalApplicationLinkObservable.pipe(takeUntil(unSubscribeOnViewDestroy)).subscribe((externalApplicationLink: string) => {
      target.onblur = (): any => {
        dialogBuilder.close();
      };
      target.focus();

      try {
        this.window.location = externalApplicationLink;
      } catch {
        this.window.location = externalApplicationLink.replaceAll('//', '///'); //fallback for MsEdge, where it expects an authority seperator to validate the URI
      }
    });
  }
}
